import React from 'react';
import { Center, Spinner as ChakraSpinner } from '@chakra-ui/react';

const Spinner = () => (
  <Center h="100vh">
    <ChakraSpinner size="xl" thickness="4px" />
  </Center>
);

export default Spinner;
